"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */

var SortOptions = require("./SortOptions");
var _require = require("./SortOptions"),
  SortDirection = _require.SortDirection;
var FilterOptions = require("./FilterOptions");
module.exports = /*#__PURE__*/function () {
  function DataFilter(limit) {
    (0, _classCallCheck2["default"])(this, DataFilter);
    this.filterOptions = new FilterOptions();
    this.sortOptions = new SortOptions();
    // this.setDebugEnabled(true)
    this._limit = limit || 1000;
  }
  (0, _createClass2["default"])(DataFilter, [{
    key: "setDebugEnabled",
    value: function setDebugEnabled(isEnabled) {
      this.isDebugEnabled = isEnabled;
      this.filterOptions.setDebugEnabled(isEnabled);
      this.sortOptions.setDebugEnabled(isEnabled);
      return this;
    }
  }, {
    key: "mergeIf",
    value: function mergeIf(otherFilter, condition) {
      var conditionRes = typeof condition === "function" ? condition() : condition;
      if (condition === undefined || conditionRes) {
        return this.merge(otherFilter);
      }
      return this;
    }
  }, {
    key: "merge",
    value: function merge(otherFilter) {
      var filter = Object.assign(new DataFilter(this.getLimit()), this);
      filter.filterOptions = filter.filterOptions.merge(otherFilter.filterOptions);
      filter.sortOptions = filter.sortOptions.merge(otherFilter.sortOptions);
      return filter;
    }
  }, {
    key: "limit",
    value: function limit(_limit) {
      return this.setLimit(_limit);
    }
  }, {
    key: "setLimit",
    value: function setLimit(limit) {
      this._limit = limit;
      return this;
    }
  }, {
    key: "getLimit",
    value: function getLimit() {
      return this._limit;
    }
  }, {
    key: "addSortAscBy",
    value: function addSortAscBy(field) {
      this.sortOptions.add(field, SortDirection.ASC);
      return this;
    }
  }, {
    key: "addSortDescBy",
    value: function addSortDescBy(field) {
      this.sortOptions.add(field, SortDirection.DESC);
      return this;
    }
  }, {
    key: "addSortOption",
    value: function addSortOption(field, direction) {
      this.sortOptions.add(field, direction);
      return this;
    }
  }, {
    key: "orderByAsc",
    value: function orderByAsc(field) {
      return this.addSortOption(field, SortDirection.ASC);
    }
  }, {
    key: "orderByDesc",
    value: function orderByDesc(field) {
      return this.addSortOption(field, SortDirection.DESC);
    }
  }, {
    key: "orderBy",
    value: function orderBy(field, direction) {
      return this.addSortOption(field, direction);
    }
  }, {
    key: "where",
    value: function where(field, operation, value) {
      return this.addFilterOption(field, operation, value);
    }
  }, {
    key: "whereIf",
    value: function whereIf(field, operation, value, condition) {
      return this.addFilterOptionIf(field, operation, value, condition);
    }
  }, {
    key: "addFilterOption",
    value: function addFilterOption(field, operation, value) {
      this.filterOptions.add(field, operation, value);
      return this;
    }
  }, {
    key: "addFilterOptionIf",
    value: function addFilterOptionIf(field, operation, value, condition) {
      var conditionRes = typeof condition === "function" ? condition() : condition;
      if (condition === undefined && value !== undefined || conditionRes) {
        return this.addFilterOption(field, operation, value);
      }
      return this;
    }
  }, {
    key: "addTextSearchFilterOption",
    value: function addTextSearchFilterOption(field, valueArray) {
      var valueMaxLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;
      var toLowerCase = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var shouldTrim = valueMaxLength && valueMaxLength > 1;
      valueArray = valueArray.map(function (value) {
        if (toLowerCase) {
          value = value.toLowerCase();
        }
        if (shouldTrim) {
          value = value.substring(0, valueMaxLength);
        }
        return value;
      });
      valueArray = valueArray.filter(function (val) {
        return !!val;
      });
      var hasData = valueArray.length > 0;
      if (hasData) {
        this.filterOptions.add(field, "object-contains-any", valueArray);
      }
      return this;
    }
  }, {
    key: "addFilterOptionArray",
    value: function addFilterOptionArray(field, value) {
      this.filterOptions.addArray(field, value);
      return this;
    }
  }, {
    key: "applyFilters",
    value: function applyFilters(ref) {
      // this.log("DataFilter.applyFilters: this = ", this)
      ref = this.filterOptions.apply(ref);
      ref = this.sortOptions.apply(ref);
      if (this.getLimit()) {
        ref = ref.limit(this.getLimit());
      }
      return ref;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.filterOptions.reset();
      this.sortOptions.reset();
      return this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.filterOptions.isEmpty() && this.sortOptions.isEmpty();
    }
  }, {
    key: "hasFilterOptions",
    value: function hasFilterOptions() {
      return !this.filterOptions.isEmpty();
    }
  }, {
    key: "hasSortOptions",
    value: function hasSortOptions() {
      return !this.sortOptions.isEmpty();
    }
  }, {
    key: "hasFilterByFieldName",
    value: function hasFilterByFieldName(fieldName) {
      return this.filterOptions.hasOptionByName(fieldName);
    }
  }, {
    key: "hasSortByFieldName",
    value: function hasSortByFieldName(fieldName) {
      return this.sortOptions.hasOptionByName(fieldName);
    }
  }, {
    key: "getFilterByName",
    value: function getFilterByName(fieldName) {
      return this.filterOptions.getOptionByName(fieldName);
    }
  }, {
    key: "whereFilterIf",
    value: function whereFilterIf(filterItem, condition) {
      var conditionRes = typeof condition === "function" ? condition() : condition;
      if (condition === undefined || conditionRes) {
        return this.whereFilter(filterItem);
      }
      return this;
    }
  }, {
    key: "whereFilter",
    value: function whereFilter(filterItem) {
      if (filterItem && Array.isArray(filterItem.filterOptions)) {
        var _this$filterOptions$f;
        (_this$filterOptions$f = this.filterOptions.filterOptions).push.apply(_this$filterOptions$f, (0, _toConsumableArray2["default"])(filterItem.filterOptions));
      }
      return this;
    }
  }, {
    key: "orStart",
    value: function orStart() {
      this.filterOptions.orStart();
      return this;
    }
  }, {
    key: "andStart",
    value: function andStart() {
      this.filterOptions.andStart();
      return this;
    }
  }, {
    key: "orEnd",
    value: function orEnd() {
      this.filterOptions.orEnd();
      return this;
    }
  }, {
    key: "andEnd",
    value: function andEnd() {
      this.filterOptions.andEnd();
      return this;
    }
  }]);
  return DataFilter;
}();